import {api} from '@/http'

// 菜单添加
const addMenu = (data, callback, back) => {
  api('/api/Authority/insert', 'post', data, callback, back)
}

// 菜单删除
const delMenu = (ids, callback, back) => {
  api('/api/Authority/delete', 'post', ids, callback, back)
}

// 角色列表
const getRoleList = (data, callback, back) => {
  api('/api/Role/List', 'post', data, callback, back)
}

// 角色添加
const addRole = (data, callback, back) => {
  api('/api/Role/Insert', 'post', data, callback, back)
}

// 角色删除
const delRole = (ids, callback, back) => {
  api('/api/Role/Delete', 'post', ids, callback, back)
}

// 权限列表
const getRoleAuthority = (id, callback, back) => {
  api('/api/Authority/ListRoleAuthority', 'post', {Id: id}, callback, back)
}

// 权限分配
const setRoleAuthority = (data, callback, back) => {
  api('/api/Authority/AssignRoleAuthority', 'post', data, callback, back)
}

// 用户列表
const getUserList = (data, callback, back) => {
  api('/api/User/List', 'post', data, callback, back)
}

// 用户删除
const delUser = (ids, callback, back) => {
  api('/api/User/Delete', 'post', ids, callback, back)
}

// 用户添加
const addUser = (data, callback, back) => {
  api('/api/User/Insert', 'post', data, callback, back)
}

// 部门下来
const getDepartmentList = (callback, back) => {
  api('/api/Main/SelectList', 'post', {TypeName: 'department'}, callback, back)
}

export default {
  addMenu,
  delMenu,
  getRoleList,
  addRole,
  delRole,
  getRoleAuthority,
  setRoleAuthority,
  getUserList,
  delUser,
  addUser,
  getDepartmentList
}



// WEBPACK FOOTER //
// ./src/api/admin/index.js